package com.vamvisions.main.core.presentation.i18n

object RoStrings : Strings {
    override val navHome = "Acasă"
    override val navPortfolio = "Portofoliu"
    override val navProjects = "Proiecte"
    override val navContact = "Contact"
    override val mainNavigationLabel = "Navigare principală"
    override val skipToContent = "Sari la conținutul principal"

    override val switchToDarkScheme = "Comută la tema întunecată"
    override val switchToLightScheme = "Comută la tema luminoasă"
    override val changeLanguage = "Schimbă limba"

    override val homeTitle = "Acasă"
    override val portfolioTitle = "Portofoliu"
    override val projectsTitle = "Proiecte"
    override val contactTitle = "Contact"
    override val notFoundTitle = "Pagina nu a fost găsită"

    override val notFoundMessage = "Pagina pe care o cauți nu există."
    override val backToHome = "Înapoi la pagina principală"

    override val errorNoConnection = "Serverul nu a putut fi contactat. Verifică conexiunea și încearcă din nou."
    override val errorNotFound = "Conținutul cerut nu a fost găsit."
    override val errorServer = "A apărut o eroare pe server. Te rugăm să încerci mai târziu."
    override val errorInvalidResponse = "Serverul a trimis un răspuns care nu a putut fi citit."
    override val errorUnknown = "A apărut o eroare. Te rugăm să încerci din nou."
    override val errorBadRequest = "Mesajul nu a putut fi acceptat. Verifică câmpurile și încearcă din nou."
    override val errorTooManyRequests = "Au fost trimise prea multe mesaje. Te rugăm să încerci mai târziu."

    override val loading = "Se încarcă…"
    override val retry = "Reîncearcă"

    override val introTitle = "\uD83C\uDF40 Bună, sunt Ana Maria Vîlcu"
    override val introSubtitle = "Dezvolt aplicații Kotlin Multiplatform — și îmi place să transform ideile în produse pe care oamenii " +
        "le folosesc cu plăcere."
    override val highlightExperienceUnit = "ani"
    override fun highlightExperienceTitle(years: Int) = "$years+ ani"
    override val highlightExperienceAccent = "de experiență profesională"
    override val highlightExperienceText = "Dezvolt aplicații Android din 2018, de la terminale de plată și banking la aplicații pentru " +
        "publicul larg pe Google Play."
    override val highlightTechnicalTitle = "Abilități tehnice"
    override val highlightTechnicalAccent = "Îndrumată de Philipp Lackner și echipa sa"
    override val highlightTechnicalText = "Sesiuni live de Q&A cu Philipp și suport pe Slack de la echipa lui, în timp ce dezvolt cu " +
        "Kotlin Multiplatform."
    override val highlightBusinessTitle = "Abilități de business"
    override val highlightBusinessAccent = "Susținută de echipa Monetise a lui Iman Gadzhi"
    override val highlightBusinessText = "Mai multe sesiuni de Q&A în fiecare săptămână despre creșterea și scalarea unui produs."

    override val connectTitle = "\uD83E\uDD1D Hai să ținem legătura"
    override val connectText = "Ai un proiect în minte, o întrebare despre munca mea sau vrei doar să saluți? Mi-ar plăcea să aflu de la tine."
    override val connectLink = "Contactează-mă"

    override val portfolioIntroTitle = "\uD83C\uDF31 Parcursul meu de până acum"
    override val portfolioIntroText = "Astăzi dezvolt aplicații Kotlin Multiplatform sub propriul nume, VAMVisions, cu șapte ani de experiență " +
        "în echipe de produs Android și un an investit în dezvoltarea abilităților mele."
    override val portfolioExperienceEyebrow = "Experiență"
    override val portfolioExperienceTitle = "De la echipe de produs la propriul studio"
    override val portfolioLearningEyebrow = "Învăț acum"
    override val portfolioLearningTitle = "Mereu în învățare"
    override val portfolioEducationEyebrow = "Educație"
    override val portfolioEducationTitle = "Unde a început totul"
    override val portfolioSeeProjects = "Vezi proiectele mele"
    override val portfolioWorkWithMe = "Hai să lucrăm împreună"

    override val contactIntroTitle = "\uD83D\uDC4B Hai să vorbim"
    override val contactIntroText = "Ai o idee de aplicație, un produs digital la care te gândești sau un parteneriat de explorat? Povestește-mi puțin " +
        "despre ce ai în minte. Aștept cu drag mesajul tău."
    override val contactPhotoAlt = "Ana Maria Vîlcu zâmbind într-o grădină japoneză din Kyoto"
    override val contactReachTitle = "Scrie-mi direct"
    override val contactFormTitle = "Povestește-mi"
    override val contactTopicLabel = "Despre ce este vorba?"
    override val contactOptional = "(opțional)"
    override val contactTopicAppDevelopment = "Dezvoltare de aplicații"
    override val contactTopicDigitalProduct = "Creare de produse digitale"
    override val contactTopicPartnership = "Parteneriat"
    override val contactTopicOther = "Altceva"
    override val contactNameLabel = "Nume (opțional)"
    override val contactNamePlaceholder = "Cum să-ți spun?"
    override val contactEmailLabel = "Emailul tău"
    override val contactEmailPlaceholder = "tu@exemplu.com"
    override val contactMessageLabel = "Mesaj"
    override val contactMessagePlaceholder = "Câteva rânduri despre ideea ta, termene sau întrebarea ta…"
    override val contactSend = "Trimite mesajul"
    override val contactSending = "Se trimite…"
    override val contactSent = "Mulțumesc! Mesajul tău a fost trimis. Îți voi răspunde în curând."
    override val contactSendFailed = "Ceva nu a mers și mesajul tău nu a fost trimis. Încearcă din nou sau scrie-mi direct pe email."
    override val errorFieldRequired = "Acest câmp este obligatoriu."
    override val errorEmailInvalid = "Te rog să introduci o adresă de email validă."
    override val errorMessageRequired = "Te rog să scrii un mesaj."
    override val errorMessageTooShort = "Mesajul trebuie să aibă cel puțin 10 caractere."
    override val errorMessageTooLong = "Mesajul trebuie să aibă cel mult 5000 de caractere."
    override val errorNameTooLong = "Numele trebuie să aibă cel mult 100 de caractere."

    override val projectsIntroTitle = "\uD83D\uDEE0\uFE0F Ce am construit"
    override val projectsIntroText = "De la primele mele aplicații Java pe Google Play până la produsele Kotlin Multiplatform de astăzi. Fiecare m-a " +
        "învățat ceva ce aduc în fiecare proiect nou."
    override val projectsNowEyebrow = "Acum"
    override val projectsNowTitle = "La ce lucrez"
    override val projectsEarlierEyebrow = "Aplicații anterioare · 2018–2021"
    override val projectsEarlierTitle = "Unde a început totul"
    override val projectsConnectTitle = "\uD83E\uDD1D Ai o idee de aplicație?"
    override val projectsConnectText = "Mi-ar plăcea să aflu despre ea. Hai să vedem cum o putem construi împreună."
    override val comingSoon = "În curând"
    override val visitSite = "Vezi site-ul"
    override val privacyPolicy = "Politică de confidențialitate"
    override val sourceCode = "Cod sursă"

    override val documentTable = "Tabel"

    override val present = "prezent"
    override val shortMonthNames = listOf(
        "ian.", "feb.", "mar.", "apr.", "mai", "iun.", "iul.", "aug.", "sept.", "oct.", "nov.", "dec.",
    )

    override val openMenu = "Deschide meniul"
    override val closeMenu = "Închide meniul"
}
